<div *ngIf="toggled && showMinimize" class="jmCollapseTitleLearnMore">
	<div class="jmPageTitle" style="padding-top: 10px;">
		{{title}}
		<div (click)="toggleCollapse()" class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-plus-square"></div>
	</div>
</div>

<div id="{{objectIdForCollapsingWidget}}" *ngIf="!toggled" [hidden]="toggled" class="jmWidgetPadding">
	<div class="w-100" style="height:6%">
		<div class="jmPageTitle" style="padding-bottom: 10px;">
			{{title}}
			<div (click)="toggleCollapse()" *ngIf="showMinimize" class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-minus-square" style="right: 0px; margin-top:10px;"></div>
		</div>
	</div>
	<div class="row">
		<div class="col-6" style="text-align:center;">
			<div class="section-heading-wrapper" style="height:80px; margin-bottom:10px;">
				<span>Graduation Rate</span>
				<i class="jmInfoCircle" style="margin-left:5px" (click)="displayInfoWrapper('Graduation Rate','The graduation rate within 150 percent of the expected time to completion (typically six years for schools that award predominantly four-year degrees and three years for schools that award predominantly two-year degrees). These rates are only for full-time students enrolled for the first time.', 'graduationRate')"></i>
			</div>
			<figure class="meter" style="margin:0px 0px 40px 0px;">
				<picc-meter [attr.max]="data.Graduation.Max" [attr.average]="data.Graduation.Average" [attr.national-average]="data.Graduation.NationalAverage">
					<div class="picc-meter-bar" [ngStyle]="{'height':data.Graduation.AveragePcnt+'%'}"></div>
					<div class="picc-meter-line" [ngStyle]="{'bottom':data.Graduation.NationalAveragePcnt+'%'}"><span class="label">{{data.Graduation.NationalAveragePcnt}}%</span></div>
				</picc-meter>
				<figcaption><span *ngIf="data.Graduation.Average>0">{{data.Graduation.AveragePcnt}}%</span><span *ngIf="data.Graduation.Average==0">Data not available</span></figcaption>
			</figure>
			<div *ngIf="lgView===true">---- National Average</div>
		</div>

		<div class="col-6" style="text-align:center;">
			<div class="section-heading-wrapper" style="height:80px; margin-bottom:10px; ">
				<span>Students Who Return After Their First Year</span>
				<i class="jmInfoCircle" style="margin-left:5px" (click)="displayInfoWrapper('Students Who Return After Their First Year','The share of first-time, full-time undergraduates who returned to the institution after their freshman year.', 'studentReturn')"></i>
			</div>
			<figure class="meter" style="margin:0px 0px 40px 0px;">
				<picc-meter [attr.max]="data.Retention.Max" [attr.average]="data.Retention.Average" [attr.national-average]="data.Retention.NationalAverage">
					<div class="picc-meter-bar" [ngStyle]="{'height':data.Retention.AveragePcnt+'%'}"></div>
					<div class="picc-meter-line" [ngStyle]="{'bottom':data.Retention.NationalAveragePcnt+'%'}"><span class="label">{{data.Retention.NationalAveragePcnt}}%</span></div>
				</picc-meter>
				<figcaption><span *ngIf="data.Retention.Average>0">{{data.Retention.AveragePcnt}}%</span><span *ngIf="data.Retention.Average==0">Data not available</span></figcaption>
			</figure>
		</div>	
	</div>
	<div class="row" *ngIf="lgView===false">
	<div class="offset-2 col-10 spacer-bottom">---- National Average</div>
	</div>
</div>
